import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import DialogActions from "@mui/material/DialogActions";

interface Props {
  baseId: string;
  isEditMode: boolean;
  onClose: () => void;
  handleEditWorkspace: () => void;
  handleSaveNewWorkspace: () => void;
  isApplyButtonDisabled: boolean;
  isProcessing?: boolean;
}

export function WorkspaceDialogActions(props: Props) {
  const applyLabel = props.isEditMode ? "Save" : "Create Project";
  const processingLabel = props.isEditMode ? "Saving…" : "Creating…";

  return (
    <DialogActions
      id={`${props.baseId}-dialog-actions`}
      sx={{
        display: "flex",
        justifyContent: "space-between",
        padding: "20px",
      }}
    >
      <Button
        data-testid="workspace-dialog-cancel-btn"
        onClick={props.onClose}
        color="secondary"
        variant="outlined"
        disabled={props.isProcessing}
      >
        Cancel
      </Button>
      <Button
        onClick={
          props.isEditMode
            ? props.handleEditWorkspace
            : props.handleSaveNewWorkspace
        }
        color="primary"
        variant="outlined"
        disabled={props.isApplyButtonDisabled}
        data-testid="workspace-dialog-apply-button"
        startIcon={
          props.isProcessing ? (
            <CircularProgress size={16} color="inherit" />
          ) : null
        }
      >
        {props.isProcessing ? processingLabel : applyLabel}
      </Button>
    </DialogActions>
  );
}
